// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".typeform[data-v-50986eb3]{margin-top:-150px;width:100%;height:700px}@media only screen and (max-width:600px){.typeform[data-v-50986eb3]{margin-top:0;width:100%;height:400px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
